import React, { useEffect } from "react";
import { SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import SingleRecruitment from "../AcademySwimmingRecruitment/SingleRecruitment/index";
import useSwimmingRecruitmentExercises from "../AcademySwimmingRecruitment/hooks/useSwimmingRecruitmentExercises";

interface IProps {
  saleStep: SaleStep;
}

const AcademySwimmingRecruitmentModule: React.FC<IProps> = ({ saleStep }) => {
  const { getRecruitmentExercises, exercises, loading } = useSwimmingRecruitmentExercises();

  useEffect(() => {
    getRecruitmentExercises(saleStep.exerciseName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const highlightedFeatures = [
    saleStep.highlightedFeature1,
    saleStep.highlightedFeature2,
    saleStep.highlightedFeature3,
  ].filter(Boolean) as string[];

  if (loading) return <EASkeletonLoader height="200px" />;

  if (exercises.length > 0) {
    return (
      <div className="module-list">
        {exercises.map((item, index) => (
          <SingleRecruitment item={item} key={index} saleStep={saleStep} highlightedFeatures={highlightedFeatures} />
        ))}
      </div>
    );
  }

  return null;
};

export default AcademySwimmingRecruitmentModule;
